import { Breadcrumbs, Divider, Grid, Link, useMediaQuery } from '@mui/material'
import React, { useEffect } from 'react'
import { Outlet, useNavigate, useSearchParams } from 'react-router-dom'
import GlobalPageHeaderText from '../../../../utility/globalPageHeaderText'
import globalStyles from '../../../../../assets/styles/global.module.scss'
import AddIcon from '@mui/icons-material/Add'
import styles from "../../../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss";
import { IntegrationContext, IntegrationContextPayload } from '../../../../../context/integrationContext'
import { GenericDataContext, GenericDataContextPayload } from '../../../../../context/genericDataContext'
import { accountSetupBreadcrumb, channelsBreadcrumb, homeBreadcrumb, slackChannelsBreadcrumb } from '../../../../../utils/breadcrumb'

const SlackIntegration = () => {
    const navigate = useNavigate();
    const { slackIntegrations } = React.useContext(IntegrationContext) as IntegrationContextPayload; 
    const { setBreadCrumbs } = React.useContext(GenericDataContext) as GenericDataContextPayload;
    
    const [searchParams] = useSearchParams()
    let id = searchParams.get('id')
    const smallScreen = useMediaQuery('(max-width : 600px) and (min-width : 0px)')
    let pathname = window.location.pathname.toLowerCase();

    const getSlackTeamName = () => {
        let slack_team_name = "Slack Business"; 
        if(slackIntegrations){
            const obj = slackIntegrations.find((slackIntegration) => slackIntegration.slack_integration_id === Number(id)); 
            if(obj){
                slack_team_name = obj.slack_team_name;
            }
        }
        return slack_team_name;
    }   

    useEffect(() => {
        const updatedBreadcrumbs = [
            homeBreadcrumb, 
            {...channelsBreadcrumb}, 
            {name: getSlackTeamName(), path: `/channels/viewintegration/slack?id=${id}`, isActive: false, isSamePageRedirecting: pathname === "/channels/viewintegration/slack"}, 
            pathname === "/channels/viewintegration/slack" ? {...accountSetupBreadcrumb, isActive: true} : { ...slackChannelsBreadcrumb, isActive: true }
        ];
        setBreadCrumbs(updatedBreadcrumbs);
    }, [id, slackIntegrations, pathname])

    return (
        <>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={`${globalStyles.fullwidth} 
            ${styles.templateWrapper}
            `}>
                <Grid container sx={{ padding: { xs: "15px 20px 0px 20px", lg: "25px 25px 0px 27px" } }}>
                    <Grid item xs={12}>
                        <Grid container className={globalStyles.createChatbotContainer}>
                            <Grid item xl={6} lg={5} md={9} sm={9} xs={9} sx={{ marginBottom: { xs: "0px", lg: "10px" } }}>
                                <GlobalPageHeaderText
                                    mainHeadText={
                                        pathname === '/channels/viewintegration/integration/templatemessages' && id ? "Template Messages" :
                                            pathname === '/channels/viewintegration/integration/templateinfo' && id ? "Template Info" :
                                                pathname === '/channels/viewintegration/integration/pages' && id ? "Pages" :
                                                    // id ? "WhatsApp Integration" : "New Integration"}
                                                    id ? "Account Setup" : "New Channel"}
                                    flagMainTextOnly
                                />
                            </Grid>
                            {!smallScreen && <Divider className={`${globalStyles.fullwidth} ${globalStyles.dividerStyles}`} />}
                            <Outlet />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

        </>
    )
}

export default SlackIntegration
